import { CSSObject } from '@chakra-ui/react';
import { MyBetsSchema } from './MyBets.styles';

export const myBetsStyles: MyBetsSchema = {
  buttonShowMoreProps: {
    variant: 'solid',
    fontWeight: 'normal',
    py: '0',
    lineHeight: 'normal',
  },
};

export const FlexBetCard: CSSObject = {
  rowGap: '2',
  w: '100%',
};

export const NoResultsText: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'bold',
  color: 'white',
};
